<template>
  <div>
  <nav :class="{ navbar : true, fold_navBar : foldData.flag}">
    <div class="aui-navbar__header">
      <h1 class="aui-navbar__brand">
        <el-image style="width:50px"  :src="require('@/assets/image/yuanhui.png')" fit="fit">
        </el-image>
        <a class="aui-navbar__brand-lg" href="javascript:;">天津大学浙江研究院</a>
      </h1>
    </div>
    <div class="aui-navbar__body">
      <el-menu class="aui-navbar__menu mr-auto" mode="horizontal">
        <el-menu-item index="1" @click="openFold()"> 
          <i class="el-icon-s-fold icon-svg aui-navbar__icon-menu aui-navbar__icon-menu--switch"></i>
        </el-menu-item>
        <el-menu-item index="2" @click="goIndex()">
          <i class= "el-icon-s-home"> </i>
        </el-menu-item>
      </el-menu>
      <el-menu class="aui-navbar__menu" mode="horizontal">
        <!-- <el-menu-item index="2">
          <a href="https://www.renren.io/" target="_blank">
            <svg class="icon-svg aui-navbar__icon-menu" aria-hidden="true"><use xlink:href="#icon-earth"></use></svg>
          </a>
        </el-menu-item>
        <el-menu-item index="2">
          <a href="https://gitee.com/renrenio/renren-security" target="_blank">
            <svg class="icon-svg aui-navbar__icon-menu" aria-hidden="true"><use xlink:href="#gitee"></use></svg>
          </a>
        </el-menu-item>
        <el-menu-item index="4" @click="fullscreenHandle()">
          <svg class="icon-svg aui-navbar__icon-menu" aria-hidden="true"><use xlink:href="#icon-fullscreen"></use></svg>
        </el-menu-item> -->
        <el-menu-item index="5" class="aui-navbar__avatar">
          <el-dropdown placement="bottom" :show-timeout="0">
            <span class="el-dropdown-link">
              <!-- <img src="~@/assets/img/avatar.png"> -->
              <span>{{ userInfo.fullName }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="logoutHandle()">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu-item>
      </el-menu>
    </div>
   
  </nav>
  <aside :class="{ 'sideBar' : true, 'fold_sideBar' : foldData.flag}">
    <div class="aui-sidebar__inner">
        <el-menu 
        ref="menu"
        :collapse="foldData.flag"
        :unique-opened="true"
        :collapseTransition="true"
        @select="handleMenuSelect">
        <el-submenu v-for="item in menuList" :index="item.id.toString()" :key = "item.id">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </template>
          <el-menu-item v-for=" ite in item.children"  :index="ite.id.toString()"  :key = "ite.id">
            <template slot="title">
              <i :class="ite.icon"></i>
              <span slot="title">{{ite.name}}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </aside>
  <div class="aui-content__wrapper">
    <main  :class="{'aui-content': true ,'fold-aui-content' : foldData.flag,'aui-content--tabs':true }">
    <!-- tab展示内容 -->
    <template v-if="true">
      <el-dropdown class="aui-content--tabs-tools">
        <i class="el-icon-arrow-down"></i>
        <el-dropdown-menu slot="dropdown" :show-timeout="0">
          <el-dropdown-item @click.native="tabRemoveHandle(contentTabsActiveName)">关闭当前标签</el-dropdown-item>
          <el-dropdown-item @click.native="tabsCloseOtherHandle()">关闭其余那些标签</el-dropdown-item>
          <el-dropdown-item @click.native="tabsCloseAllHandle()">关闭所有标签</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-tabs v-model="contentTabsActiveName"  @tab-remove="tabRemoveHandle">
        <el-tab-pane
          v-for="item in contentTabs"
          :key="item.id"
          :name="item.name"
          :label="item.title"
          :closable="item.name !== 'home'"
          :class=" 'is-iframe'">
          <template v-if="item.name === 'home'">
             <span slot="label"><i class="el-icon-s-home icon-svg aui-content--tabs-icon-nav"></i> </span>
          </template>
          <iframe v-if="tabIsIframe(item.url)" :src="item.iframeURL" width="100%" height="100%" frameborder="0" scrolling="yes"></iframe>
        
        </el-tab-pane>
      </el-tabs>
    </template>
    </main>
  </div>
  </div>
</template>
<script>

import logo from "@/assets/image/yuanhui.png"
import { TOKEN_ID } from '@/mutation/mutConst'
import debounce from 'lodash/debounce'
import axios from  '@/api/axiosConfig'
import {MESSAGE_DURATION} from  '@/api/constant'
import SERVICE_URL from '@/api/url'
export default {
  name : 'pc_ctr_index',
  data () {
    return {
      logo,
      contentTabsActiveName :"home",
      contentTabs : [{
        id: 0,
        name :"home",
        title:"home",
        iframeURL:"/#/pc_ctr_home"
      }],
      updatePasswordVisible: false,
      messageTip: false,
      state :false,
      fold : true ,
      foldData: {
        flag : true,
        fold_navBar : true,
        fold_sideBar : true,
        fold_content: true,
      },
      userInfo:{
          usrName:'',
          fullName :''

      },
      menuList : [
        
      ] ,
      menuListCache:[]
    }
  },
  components: {
    // UpdatePassword
    // MainContent,
    // SubMenu
  },
  created () {
    this.windowResizeHandle()
    
    this.initMenu(1,true);
    // this.routeHandle(this.$route)
  },
  methods: {

    // 初始化加载菜单
    initMenu (roleId,flush){
      let dat = {roleId: roleId}
      let s = JSON.stringify(dat)
      let url = "/bc/exa/menu/getMenusAndRoles"
      axios.post(url, s).then((response) => {
        if (response.data.code === 0) {


          let dat = response.data.data;

          
          this.userInfo = {...dat.usrInfo }

          if(dat.menuTree.length !== 0){
            this.menuList = []
            this.menuListCache  = []
            for (let i = 0; i < dat.menuTree.length; i++) {
              let node = dat.menuTree[i];
              let item = {
                id: node.id,
                name : node.name,
                url : node.url,
                icon :node.icon,
                children: []
              }
              this.menuListCache.push(item);
              let subNodeList = node.list
              if( subNodeList != null && subNodeList.length != 0 ){
                for(let j =0 ; j< subNodeList.length ; j++ ){
                  let subNode = subNodeList[j];
                  let ite = {
                    id: subNode.id,
                    name : subNode.name,
                    icon :subNode.icon,
                    url : subNode.url,
                  }
                  item.children.push(ite)
                  this.menuListCache.push(ite);
                }
              }
              this.menuList.push(item);
            }
          } else {
            this.$message({
              showClose: true,
              message: '未查询到菜单信息信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    
    handleMenuSelect(index, indexPath){
      if(this.menuListCache.length == 0){
        return 
      }

      const item = this.menuListCache.find(item => item.id.toString() === index);
      if (item == null ) {
        this.$message({
          showClose: true,
          message: '未找到该菜单信息',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return
      }
      if(item.url == '' || item.url == null){
        this.$message({
          showClose: true,
          message: '未配置资源路径',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }

      const itemTab = this.contentTabs.find(item => item.id.toString() === index)
      if(itemTab == null) {
          this.contentTabs.push({
          id: item.id,
          name:item.name,
          title:item.name,
          iframeURL: SERVICE_URL + "/#/" + item.url 
        })
        this.contentTabsActiveName = item.name
      }else{
        this.contentTabsActiveName = itemTab.name
      }
      
    },
    openFold(){
      if(this.foldData.flag){
        this.foldData.flag = false
      }else{
        this.foldData.flag = true
      }
    },
    goIndex(){

      this.$router.push({path :'/pc_index'})
    },
    windowResizeHandle () {
      this.state = document.documentElement['clientWidth'] <= 992 || false
      window.addEventListener('resize', debounce(() => {
         this.state  = document.documentElement['clientWidth'] <= 992 || false
      }, 150))
    },


    // 退出
    logoutHandle () {
      this.$confirm('即将要退出登录!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doLogout()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doLogout(){
      let dat = {}
      let url = "/bc/exa/usr/logout"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$router.push({path :'/'})
          this.$store.commit(TOKEN_ID, '')
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })

    },
    tabIsIframe (url) {
      return true;
    },
   

    // tabs, 删除tab
    tabRemoveHandle (tabName) {

      if (tabName === 'home') {
        return 
      }
      this.contentTabs =  this.contentTabs.filter(item => item.name !== tabName)
   
      this.contentTabsActiveName = this.contentTabs[this.contentTabs.length  - 1].name
      
    },
    // tabs, 关闭其它
    tabsCloseOtherHandle () {
      this.contentTabs = this.contentTabs.filter(item => 
         item.name === 'home' ||  item.name == this.contentTabsActiveName
      )
      this.contentTabsActiveName = this.contentTabs[this.contentTabs.length  - 1].name
    },
    // tabs, 关闭全部
    tabsCloseAllHandle () {
      this.contentTabs = this.contentTabs.filter(item => item.name === 'home' )
      this.contentTabsActiveName = this.contentTabs[this.contentTabs.length  - 1].name
    }
  }
}
</script>
<style lang="less" scoped>

.mr-auto {
  margin-right: auto !important;
}

.icon-svg {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: middle;
  overflow: hidden;
}

.aui-content--tabs-tools {
  position: fixed;
  top: 50px;
  right: 0;
  z-index: 931;
  min-width: 30px;
  height: 38px;
  padding: 0 12px;
  text-align: center;
  font-size: 16px;
  line-height: 38px;
  background-color: #fff;
  border-left: 1px solid gainsboro;
  cursor: pointer;
}
.navbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  display: flex;
  align-items: stretch;
  height: 50px;
   background-color: #17B3A3;
  // background-color: #ecede4;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, .05);
  .aui-navbar__header {
    position: relative;
    width:  230px;
    height: 50px;
    transition: width .3s;
  }
  .aui-navbar__brand {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    margin: 0;
    width: 100%;
    height: 100%;
    font-size: 20px;
    text-transform: uppercase;
    white-space: nowrap;
    color: #fff;
    overflow: hidden;
    transition: width .3s;
    .aui-navbar__brand-lg,
    .aui-navbar__brand-mini {
      text-align: center;
      width:  100%;
      max-width: 100%;
      color: #fff;
      cursor: pointer;
      &:focus,
      &:hover {
        color: #fff;
        text-decoration: none;
      }
    }
    .aui-navbar__brand-mini {
      display: none;
    }
  }
  .aui-navbar__body {
    position: relative;
    display: flex;
    flex: 1;
    background-color: #17B3A3;
    overflow: hidden;
  }
  .aui-navbar__menu {
    background-color: transparent;
    border-bottom: 0 !important;
    a:focus,
    a:hover {
      text-decoration: none;
    }
    .el-menu-item,
    .el-submenu > .el-submenu__title {
      height: 50px;
      padding: 0 15px;
      line-height: 50px;
      border-color: transparent !important;
    }
    .el-menu-item.is-active,
    .el-submenu.is-active > .el-submenu__title {
      color: salmon;
      &:focus,
      &:hover {
        color: salmon;
      }
    }
    .el-menu-item {
      &:focus,
      &:hover {
        .aui-navbar__icon-menu {
          color: salmon;
        }
        .el-dropdown {
          color: salmon;
          .el-icon-arrow-down {
            transform: rotateZ(180deg);
          }
        }
      }
      * {
        vertical-align: initial;
      }
      .aui-navbar__icon-menu {
        vertical-align: middle;
        font-size: 16px;
      }
      .el-dropdown {
        color: salmon;
        .el-icon-arrow-down {
          width: auto;
          font-size: 12px;
          margin: 0 0 0 5px;
          transition: transform .3s;
        }
      }
    }
    .el-badge {
      display: inline;
      z-index: 2;
      &__content {
        line-height: 16px;
      }
    }
  }
  .aui-navbar__search {
    > *[class*="el-icon-"],
    > *[class*="icon"] {
      display: inline-block;
      vertical-align: middle;
    }
    &-txt {
      width: 0;
      transition: width .3s, margin-left .3s;
      &.is-show {
        width: 210px;
        margin-left: 8px;
      }
      .el-input__inner {
        height: 30px;
        padding: 0;
        line-height: 30px;
        border-color: salmon;
        border-top: 0;
        border-right: 0;
        border-left: 0;
        border-radius: 0;
        background: transparent;
      }
    }
  }
  .aui-navbar__avatar {
    .el-dropdown-link {
      > img {
        width: 36px;
        height: auto;
        margin-right: 5px;
        border-radius: 100%;
        vertical-align: middle;
      }
    }
  }
}

.fold_navBar {
  .aui-navbar__header,
  .aui-navbar__brand {
    width: 64px;
  }
  .aui-navbar__brand {
    .aui-navbar__brand-lg {
      display: none;
    }
    .aui-navbar__brand-mini {
      width:  100%;
      max-width: 100%;
      display: inline-block;
    }
  }
  .aui-navbar__brand__icon-menu--switch {
    transform: rotateZ(180deg);
  }
}

.sideBar {
  position: fixed;
  top: 50px;
  left: 0;
  bottom: 0;
  z-index: 1020;
  width: 230px;
  background-color: #fff;
  box-shadow: 1px 0 2px 0 rgba(0, 0, 0, .05);
  overflow: hidden;
  color: salmon;
  transition: width .3s;
  .aui-sidebar__inner {
    position: relative;
    z-index: 1;
    width: 230px;
    height: 100%;
    padding-bottom: 15px;
    background-color: #263238;
    overflow-x: hidden;
    overflow-y: scroll;
    transition: width .3s;
    .el-menu  {
      background-color: #263238;
      border-right: #263238 !important;
    }

    /deep/ .el-submenu__title{
          color: #dde !important;
          &:focus,
          &:hover {
            color: rgb(38, 184, 189);
            background-color: rgb(112, 134, 135);
          }
          .el-icon-location,.el-icon-arrow-down{
            color: #dde !important;
          }
      }
    
    // .el-submenu.is-active > .el-submenu__title
    .el-menu-item{
      background-color: #263238;
      color: #dde;

      padding-left: 60px  !important;

    }
    .el-menu-item.is-active {
      background-color: #17B3A3;
    }
  }
}
.fold_sideBar {
  width: 64px;
  .aui-sidebar__inner {
    width: 64px;
  }
  .aui-sidebar,
  .aui-sidebar__menu {
    width: 64px;
  }
  .aui-sidebar__menu > li > .el-submenu__title {
    text-align: center;
  }
  .aui-sidebar__menu-icon {
    margin-right: 0;
    font-size: 18px;
  }
}

.aui-content__wrapper {
    position: relative;
    margin-left: 100px;
    min-height: calc(100vh - 50px);
    background-color: rgb(230, 236, 228);
    transition: margin-left .3s;
}
/deep/.aui-sidebar__inner::-webkit-scrollbar {
    width: 0px; // 横向滚动条
    height: 0px; // 纵向滚动条 必写
}
/deep/.aui-sidebar__inner::-webkit-scrollbar-thumb {
    background-color: #263238;
    border-radius: 0px;
}


  .aui-content{
  position: relative;
  padding: 15px;
  min-height: calc(100vh - 50px);
 }
 .aui-content .el-tabs {
    position: fixed;
    top: 50px;
    left: 230px;
    right: 0;
    z-index: 930;
    padding: 0 10px 10px 10px;               
    margin: 0;
    background-color: gainsboro;
 }
 .aui-content .el-tabs .el-tabs__header {
      top: 50px;
      left: 230px;
      right: 0;
      z-index: 930;
      padding: 0 75px 0 15px;
      margin: 0;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
      background-color: #fff;
      transition: left .3s;
 }
/deep/.el-tabs__nav-wrap{
  background-color: #fff;
    margin-bottom: 0;
    transition: left .3s;
    &:after {
      display: none;
    }
    > .el-tabs__nav-next,
    > .el-tabs__nav-prev {
      line-height: 38px;
    }
    > .el-tabs__nav-scroll > .el-tabs__nav {
      & > .el-tabs__active-bar {
         display: none;
      }
      & > .el-tabs__item {
        height: 38px;
        padding: 0 15px;
        line-height: 38px;
        border: 0;
        color: #606266;
        &:focus,
        &:hover{
          color: #303133;
          background-color: #fee;
          &:after {
            display: block;
          }
          > .el-icon-close {
            color: rgb(215, 56, 56);
          }
        }
        &.is-active {
          color: #303133;
          background-color:#17B3A314;
          &:after {
            display: block;
          }
          > .el-icon-close {
            color: rgb(215, 56, 56);
          }
        }
        &:after {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
          content: '';
          width: 100%;
          height: 2px;
          background-color: #409EFF;
        }
        + .el-tabs__item {
          margin-left: 1px;
        }
        > .el-icon-close {
          width: 14px;
          margin-left: 15px;
          color: #909399;
        }
        > i.icon {
          display: inline-block;
          vertical-align: middle;
          font-size: 18px;
        }
      }
    }
}
 /deep/ .el-tabs__content {
      padding: 0;
      background-color: #f1f4f5;
      .el-loading-mask {
        z-index: 830;
      }
      .el-tab-pane {
        padding: 0 15px 0 15px;
        min-height: calc(calc(100vh - 50px - 38px - 30px));
        > .aui-card--fill > .el-card__body {
          min-height: calc(calc(100vh - 50px - 38px - 30px) - 2px);
        }
        > .aui-card--fill > .el-card__header + .el-card__body {
          min-height: calc(calc(100vh - 50px - 38px - 30px) - 60px - 2px);
        }
        &.is-iframe {
          height: calc(calc(100vh - 50px - 38px - 30px) + 30px);
          margin: -15px;
          min-height: auto;
          overflow: hidden;
        }
    }
}

.fold-aui-content{
  .el-tabs {
    left:  64px;
    .el-tabs__header {

      left:  64px;
    }
  }
} 
</style>


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_index.vue